import request from '@/assets/js/utils/request'

export function CreateFaceInfo(data){
  return request({
    url: 'AppClient/Hkws/CreateFaceInfo',
    method: 'post',
    data
  })
}

export function UpdateFaceInfo(data){
  return request({
    url: 'AppClient/Hkws/UpdateFaceInfo',
    method: 'post',
    data
  })
}

export function LoadInfo(){
  return request({
    url: 'AppClient/Hkws/LoadInfo',
    method: 'post'
  })
}

export function EnterList(data){
  return request({
    url: 'AppClient/Hkws/EnterList',
    method: 'post',
    data
  })
}


export function GetToken(){
  return request({
    url: 'AppClient/Hkws/GetToken',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/api/rllr.js